import { render, staticRenderFns } from "./FormSalasananUusimispyynto.vue?vue&type=template&id=1971d744&scoped=true&"
import script from "./FormSalasananUusimispyynto.vue?vue&type=script&lang=js&"
export * from "./FormSalasananUusimispyynto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1971d744",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1971d744')) {
      api.createRecord('1971d744', component.options)
    } else {
      api.reload('1971d744', component.options)
    }
    module.hot.accept("./FormSalasananUusimispyynto.vue?vue&type=template&id=1971d744&scoped=true&", function () {
      api.rerender('1971d744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSalasananUusimispyynto.vue"
export default component.exports